<template>
  <div class="cbt">
    <div class="mv">
      <div class="u-containar-md">
        <h1 class="hidden">全国一斉 CBT模擬試験</h1>
        <picture>
          <source
            media="(max-width: 900px)"
            srcset="@/assets/images/magazines/exam_cbt_2025_ttlSP.svg"
          />
          <img src="@/assets/images/magazines/exam_cbt_2025_ttl.svg" alt="" />
        </picture>
      </div>
    </div>
    <div class="lead">
      <div class="u-containar-md">
        <p class="support">
          問題・解説提供： マック・メディカル・アカデミー・コーポレーション
        </p>
        <div class="count">総出題数140問 / 受験時間 計150分</div>
        <p class="text">
          自分の都合に合わせていつでもオンラインCBT模擬試験を「無料」で受験できます。
        </p>
        <p class="note">
          ブラウザの戻る・進む機能を使うと、正しく動作しないことがあります。問題を移動する時は「前の問題へ」「次の問題へ」ボタンを使用してください。
        </p>
        <p class="note">
          総合成績の最新得点は、第一項〜第五項を各一回ずつ受験しないと正しく反映されない場合があります。そのため、初回の受験のみ各項一回ずつ受験して下さい。
        </p>
        <p class="note">
          成績発表の平均点や順位は、初回の得点のみ反映されます。
        </p>
      </div>
    </div>
    <div class="questions">
      <h2>模擬試験項目</h2>
      <div class="u-containar-md">
        <ul class="cards">
          <CbtTermCard
            v-for="(item, index) in results"
            :key="index"
            :data="item"
            :number="index + 1"
            :isTop="true"
          />
        </ul>
      </div>
    </div>
    <div class="toResult">
      <Button
        :label="'総合成績を見る'"
        primary
        :disabled="!activeAllResult"
        :handleClick="() => $router.push('/magazines/exam/cbt/all/result')"
      />
      <p class="note">全ての項目を受験後、ご覧いただけます。</p>
    </div>
    <div class="foot">
      <div class="u-containar-md inner">
        <div class="advantage">
          <div class="title"><span>受験</span>のメリット</div>
          <ul>
            <li>ここだけのオリジナル問題！</li>
            <li>全国順位と大学内の順位が分かる！</li>
            <li>不正解でも詳しい解説付きなので安心！</li>
            <li>何度受験しても無料。自分のペースで受験しよう！</li>
          </ul>
        </div>
        <div class="supported">
          <div class="title">問題提供</div>
          <div class="img">
            <img src="@/assets/images/magazines/exam_cbt_foot.jpg" alt="" />
          </div>
          <p>
            医師国家試験予備校として、医学生におなじみのマック・メディカル・アカデミー・コーポレーション。進級試験対策から医師国家試験まで幅広く展開しています。
          </p>
          <TextLink
            class="link"
            :text="'詳しくはこちら'"
            :link="'http://www.macmic.net/'"
            :blank="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, reactive, defineComponent } from 'vue'
import { useStore } from 'vuex'
import Button from '@/components/elements/Button.vue'
import TextLink from '@/components/elements/TextLink.vue'
import CbtTermCard from '@/components/block/CbtTermCard.vue'
import { axiosSetting } from '@/utils/axiosSetting'

export default defineComponent({
  name: 'Cbt',
  components: {
    Button,
    TextLink,
    CbtTermCard
  },
  setup() {
    const results: any[] = reactive([])
    const activeAllResult = ref(false)
    const store = useStore()
    const ajax = axiosSetting('app', 'action')

    const getData = () => {
      const titles = [
        {
          title: '基本事項 / 医学一般(30問)'
        },
        {
          title: '人体各器官の正常構造と機能、病態、診断、治療(30問)'
        },
        {
          title: '全身に及ぶ生理的変化、病態、診断、治療(30問)'
        },
        {
          title: '診療の基本 / 社会と医学・医療(30問)'
        },
        {
          title: '4連問特集(20問)'
        }
      ]

      const params = {
        users_id: store.state.userInfo.zip,
        year: '2022'
      }

      ajax.post('/api/v1/cbt_previous_results', params).then((res: any) => {
        res.data.forEach((item: any, index: number) => {
          const merged = { ...item, ...titles[index] }
          results.push(merged)
        })
        activeAllResult.value = res.data.every(
          (item: any) => item.last_test_day !== ''
        )
      })
    }
    getData()

    return {
      results,
      activeAllResult
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.cbt {
  letter-spacing: 0.03em;
  line-height: 1.5;
}

.mv {
  height: 200px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('~@/assets/images/magazines/exam_cbt_bgSP.png');
  background-size: cover;
  @include mixins.media() {
    height: 240px;
    background-image: url('~@/assets/images/magazines/exam_cbt_bg.png');
  }
}

.lead {
  margin-top: 32px;
  @include mixins.media() {
    margin-top: 48px;
  }
  .support {
    font-size: 1.2rem;
    @include mixins.media() {
      text-align: right;
    }
  }
  .count {
    margin-top: 32px;
    border: 2px solid var.$color-main;
    width: 100%;
    max-width: 340px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: var.$color-main-text;
    @include mixins.media() {
      height: 50px;
      max-width: none;
      font-size: 1.7rem;
    }
  }
  .text {
    margin-top: 18px;
    line-height: 2;
    @include mixins.media() {
      text-align: center;
    }
  }
}

.questions {
  margin-top: 30px;
  @include mixins.media() {
    margin-top: 45px;
  }
  h2 {
    background-color: var.$color-sub-bg-g;
    padding: 10px 16px;
    font-size: 2rem;
    line-height: 1.6;
    @include mixins.media() {
      width: 712px;
      margin-right: auto;
      margin-left: auto;
    }
  }
  .cards {
    padding-top: 8px;
    @include mixins.media() {
      padding-top: 0;
      margin-top: -8px;
    }
    > li {
      margin-top: 16px;
      @include mixins.media() {
        margin-top: 32px;
      }
    }
  }
}

.note {
  margin-top: 12px;
  font-size: 1.2rem;
  text-indent: -1.3em;
  margin-left: 1.3em;
  &::before {
    content: '＊';
    margin-right: 2px;
  }
}

.toResult {
  margin-top: 32px;
  background-color: var.$color-other-bg;
  padding: 20px 0 28px;
  text-align: center;
  @include mixins.media() {
    margin-top: 56px;
  }
}

.foot {
  margin-top: 48px;
  @include mixins.media() {
    margin-top: 40px;
    .inner {
      display: grid;
      grid-template-columns: 430px 1fr;
      gap: 0 40px;
    }
  }
  .advantage {
    .title {
      font-weight: 500;
      font-size: 1.8rem;
      span {
        color: var.$color-main-text;
      }
    }
    ul {
      margin-top: 24px;
      padding: 16px 20px;
      font-size: 1.6rem;
      background-color: var.$color-sub-bg-g;
      li {
        text-indent: -1.35em;
        margin-left: 1.35em;
      }
      li::before {
        display: inline-block;
        content: '';
        width: 12px;
        height: 8px;
        margin-right: 10px;
        border-left: 2px solid #29ccc3;
        border-bottom: 2px solid #29ccc3;
        transform: rotate(-45deg);
        vertical-align: 2px;
      }
      li + li {
        margin-top: 6px;
      }
    }
  }
  .supported {
    margin-top: 48px;
    @include mixins.media() {
      margin-top: 0;
    }
    .title {
      font-weight: 500;
      font-size: 1.8rem;
    }
    img {
      margin-top: 25px;
    }
    p {
      margin-top: 19px;
      line-height: 1.8;
      @include mixins.media() {
        margin-top: 12px;
        font-size: 1.2rem;
      }
    }
    .link {
      display: inline-block;
      margin-top: 10px;
    }
  }
}
</style>
